var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"noun_Right_Arrow_1406453","data-name":"noun_Right Arrow_1406453","transform":"translate(1 1.414)"},React.createElement("g",{"id":"Group_2","data-name":"Group 2","transform":"translate(0 0)"},[React.createElement("path",{"id":"Path_18","data-name":"Path 18","d":"M104.012,40.9,99.8,45.336l4.436,4.212","transform":"translate(-99.8 -40.9)","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"2","key":0}),React.createElement("path",{"id":"Path_19","data-name":"Path 19","d":"M7.5,0H31.826","transform":"translate(-7.257 4.324)","fill":"none","stroke":"#000","strokeLinecap":"round","strokeWidth":"2","key":1})])));
}

Arrow.defaultProps = {"width":"26.569","height":"11.476","viewBox":"0 0 26.569 11.476"};

module.exports = Arrow;

Arrow.default = Arrow;
